// Self-executing function for Read More with early execution
(function() {
    // Function to add Read More buttons
    function addReadMoreButtons() {
        // Find all description elements - include all possible class variations
        const descriptions = document.querySelectorAll('.boost-sd__header-description, .boost-sd__header-description--as-main-4, .boost-sd-mobile__header-description, .boost-sd-mobile__description');
        
        descriptions.forEach(description => {
            // Skip if we've already processed this element
            if (description.querySelector('.read-more-btn') || description.classList.contains('read-more-processed')) return;
            
            // Mark as processed
            description.classList.add('read-more-processed');
            
            // Store original content
            const originalHTML = description.innerHTML;
            
            // Extract h3 header if present
            let headerHTML = '';
            const headerElement = description.querySelector('h3');
            if (headerElement) {
                headerHTML = headerElement.outerHTML;
            }
            
            const paragraphs = description.querySelectorAll('p');
            
            // If there are paragraphs and more than one, or content is long
            if ((paragraphs.length > 1) || (description.textContent.length > 200)) {
                // Function to handle the button click - defined outside to reuse it
                function toggleReadMore() {
                    if (description.classList.contains('expanded')) {
                        // Collapse - restore truncated view
                        description.classList.remove('expanded');
                        
                        // Keep the header and the first paragraph truncated
                        description.innerHTML = '';
                        
                        // Always add the header first if it exists
                        if (headerHTML) {
                            const headerContainer = document.createElement('div');
                            headerContainer.innerHTML = headerHTML;
                            description.appendChild(headerContainer.firstChild);
                        }
                        
                        // Now add truncated paragraph
                        const lastParaIndex = paragraphs.length > 1 ? 0 : 0; // First paragraph
                        let lastParaText = paragraphs[lastParaIndex].innerHTML;
                        
                        // Find a good breakpoint
                        const truncatePoint = Math.floor(lastParaText.length * 0.75);
                        let breakPoint = lastParaText.lastIndexOf('.', truncatePoint);
                        if (breakPoint === -1 || breakPoint < lastParaText.length * 0.5) {
                            breakPoint = lastParaText.lastIndexOf(' ', truncatePoint);
                        }
                        
                        if (breakPoint !== -1) {
                            lastParaText = lastParaText.substring(0, breakPoint + 1);
                        }
                        
                        // Create new paragraph with truncated text + "..." + button inline
                        const newPara = document.createElement('p');
                        
                        // Create text span
                        const textSpan = document.createElement('span');
                        textSpan.innerHTML = lastParaText;
                        newPara.appendChild(textSpan);
                        
                        // Add ellipsis in a span
                        const dotsSpan = document.createElement('span');
                        dotsSpan.textContent = '  ';
                        newPara.appendChild(dotsSpan);
                        
                        // Add read more button inline
                        const readMoreBtn = document.createElement('button');
                        readMoreBtn.className = 'read-more-btn read-more-btn-inline';
                        readMoreBtn.textContent = 'Read more...';
                        readMoreBtn.addEventListener('click', toggleReadMore);
                        newPara.appendChild(readMoreBtn);
                        
                        description.appendChild(newPara);
                    } else {
                        // Expand - restore original content
                        description.classList.add('expanded');
                        description.innerHTML = originalHTML;
                        
                        // Add the Read Less button at the end of the last paragraph
                        const paragraphs = description.querySelectorAll('p');
                        if (paragraphs.length > 0) {
                            const lastPara = paragraphs[paragraphs.length - 1];
                            
                            // Add a space and button at the very end
                            lastPara.innerHTML = lastPara.innerHTML + ' ';
                            
                            const readLessBtn = document.createElement('button');
                            readLessBtn.className = 'read-more-btn read-more-btn-inline';
                            readLessBtn.textContent = 'Read less...';
                            readLessBtn.addEventListener('click', toggleReadMore);
                            lastPara.appendChild(readLessBtn);
                        }
                    }
                }
                
                // Initial setup - show truncated view
                description.innerHTML = '';
                
                // Always add the header first if it exists
                if (headerHTML) {
                    const headerContainer = document.createElement('div');
                    headerContainer.innerHTML = headerHTML;
                    description.appendChild(headerContainer.firstChild);
                }
                
                // Now add truncated paragraph
                const lastParaIndex = paragraphs.length > 1 ? 0 : 0; // First paragraph
                let lastParaText = paragraphs[lastParaIndex].innerHTML;
                
                // Find a good breakpoint
                const truncatePoint = Math.floor(lastParaText.length * 0.75);
                let breakPoint = lastParaText.lastIndexOf('.', truncatePoint);
                if (breakPoint === -1 || breakPoint < lastParaText.length * 0.5) {
                    breakPoint = lastParaText.lastIndexOf(' ', truncatePoint);
                }
                
                if (breakPoint !== -1) {
                    lastParaText = lastParaText.substring(0, breakPoint + 1);
                }
                
                // Create new paragraph with truncated text + "..." + button inline
                const newPara = document.createElement('p');
                
                // Create text span
                const textSpan = document.createElement('span');
                textSpan.innerHTML = lastParaText;
                newPara.appendChild(textSpan);
                
                // Add ellipsis in a span
                const dotsSpan = document.createElement('span');
                dotsSpan.textContent = '  ';
                newPara.appendChild(dotsSpan);
                
                // Add read more button inline
                const readMoreBtn = document.createElement('button');
                readMoreBtn.className = 'read-more-btn read-more-btn-inline';
                readMoreBtn.textContent = 'Read more...';
                readMoreBtn.addEventListener('click', toggleReadMore);
                newPara.appendChild(readMoreBtn);
                
                description.appendChild(newPara);
            }
        });
    }

    // Early execution function that tries to run as soon as possible
    function earlyExecute() {
        // Check if document body exists
        if (document.body) {
            addReadMoreButtons();
            return true;
        }
        return false;
    }

    // Strategy 1: Try to run immediately
    if (earlyExecute()) {
        console.log('Read More executed immediately');
    } 
    // Strategy 2: Try during parsing
    else if (document.readyState === 'loading') {
        document.addEventListener('readystatechange', function() {
            if (document.readyState === 'interactive' && earlyExecute()) {
                console.log('Read More executed at interactive state');
            }
        });
    }
    
    // Strategy 3: Fallback to DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function() {
        addReadMoreButtons();
        console.log('Read More executed at DOMContentLoaded');
    });
    
    // Strategy 4: Multiple retries for dynamically loaded content
    const retryTimes = [500, 1000, 3000, 5000];
    retryTimes.forEach(time => {
        setTimeout(function() {
            addReadMoreButtons();
        }, time);
    });
})();


